var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ContestEntryFormLayout,
    {
      attrs: {
        "load-state": _setup.loadState,
        "error-message": _setup.errorMessage,
        "current-step": 3,
        title: _setup.t("contestEntryForm.step3.title"),
        contest: _setup.microCmsContest,
      },
    },
    [
      _setup.applicantForm && _setup.workForm
        ? _c(_setup.ContestEntryConfirmForm, {
            attrs: {
              "applicant-form": _setup.applicantForm,
              "work-form": _setup.workForm,
              "category-label": _setup.categoryLabel,
              "extra-field-items": _setup.extraFieldItems,
              submitting: _setup.submitting,
              "submit-error": _setup.submitError,
            },
            on: { back: _setup.onClickBack, submit: _setup.onClickSubmit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }